<template>
  <div class="comment-history-delete">
    <BaseSubHeading
      size="medium"
      weight="500"
      class="comment-history-delete__message"
      color="markingRed-02"
      darkColor="markingRed-03"
    >
      Deleted
    </BaseSubHeading>
    <CommentHistoryContent
      :comment="currentComment"
      :comments="comments"
      :demoVideoId="comment.demoVideoId"
      :demoVideoVersionMap="demoVideoVersionMap"
      :projectScoped="projectScoped"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import CommentHistoryContent from "@/components/Comment/CommentContent/CommentHistoryContent.vue"

import { Comment } from "@/models"

import type { DemoVideoVersionInfo } from "@/composables/useDemoVideo"

const props = defineProps({
  comment: {
    required: true,
    type: Object as () => Comment
  },
  comments: {
    required: true,
    type: Array as () => Comment[]
  },
  demoVideoVersionMap: {
    default: () => ({}),
    type: Object as () => Record<string, DemoVideoVersionInfo>
  },
  projectScoped: {
    type: Boolean,
    default: true
  }
})

const currentComment = computed(() => {
  return props.comment.commentAuditRecord?.after ?? props.comment
})
</script>

<style scoped lang="scss">
.comment-history-delete {
  &__message {
    margin-bottom: var(--step2);
  }
}
</style>
